import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {Store} from '@ngrx/store';
import {Subject, takeUntil} from 'rxjs';
import * as fromRoot from '../../../../state/app.state';
import {FetchPendingSurveyCountRequest} from '../../../page-modules/questionnaire/core/questionnaires.actions';
import {pendingSurveyCount} from '../../../page-modules/questionnaire/core/questionnaires.selectors';

@Component({
  selector: 'app-pending-survey-badge',
  templateUrl: './pending-survey-badge.component.html',
  styleUrls: ['./pending-survey-badge.component.css']
})
export class PendingSurveyBadgeComponent implements OnInit, OnDestroy {
  @Input() isSelected: boolean = false;
  
  pendingSurveyCount: number = 0;
  loading: boolean = false;
  shimmerTheme = {
    width: '2rem',
    height: '2rem',
    borderRadius: '1rem',
    baseColor: 'rgb(197, 197, 197)',
    highlightColor: 'rgb(220, 220, 220)',
    animation: {
      animationTimingFunction: 'ease-in-out',
      animationDirection: 'normal',
      animationDuration: '1.5s',
      animationIterationCount: 'infinite',
      animationName: 'shimmer'
    }
  };
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(private store: Store<fromRoot.State>) {}

  ngOnInit() {
    // Subscribe to pending survey count from store
    this.store.select(pendingSurveyCount)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.pendingSurveyCount = data?.count ?? 0;
        this.loading = data?.loading ?? false;
      });

    // Dispatch API call to fetch pending survey count
    this.store.dispatch(FetchPendingSurveyCountRequest());
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}

